import OImage from 'components/reusable/OImage';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { apiPost, apiPut } from 'utils/apiFetch';
import apiPath from 'utils/apiPath';
import ReArrangeModal from '../ReArrangeModal';
import useToastContext from 'hooks/useToastContext';
import ErrorMessage from 'components/ErrorMessage';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TAB_UPLOAD_DOCUMENTS } from '../AddProperty';
import photoClose from '../../../assets/images/photo_close.png';
import { compact, isEmpty } from 'lodash';
import OInputField from 'components/reusable/OInputField';
import OFileInput from 'components/reusable/OFileInput';
import helper from 'utils/helpers';
import { PROPERTY_ALLOWED_PHOTO_EXT } from 'utils/constants';
import AuthContext from 'context/AuthContext';

const imageCount = 6;
const imageCountMax = 20;

function Photos({
  propertyId,
  editProperty,
  setPropertyIdAndTabFn,
  getPropertyById,
  setTab,
  tabs,
}) {
  const { t } = useTranslation();
  const [photos, setPhotos] = useState(
    editProperty ? editProperty?.photos : []
  );
  const selectedPhotos = [];
  const [isFloorError, setIsFloorError] = useState('');
  const [isVideoFileError, setIsVideoFileError] = useState('');
  const [deletedImage, setDeletedImage] = useState([]);
  const [deletedVideo, setDeletedVideo] = useState([]);
  const [deletedFloorPlan, setDeletedFloorPlan] = useState([]);
  const [isShowModal, setIsShowModal] = useState(false);
  const [reArrange, setReArrange] = useState(false);
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onBlur', shouldFocusError: true, defaultValues: {} });
  const profilePicRef = useRef();
  const [videoFile, setVideoFile] = useState(editProperty?.video ?? []);
  const [createVideoUrl, setCreateVideoUrl] = useState(
    editProperty?.video ?? []
  );
  const { config } = useContext(AuthContext);

  const [floorData, setFloorData] = useState([
    {
      title: '',
      titleAr: '',
      image: '',
    },
  ]);
  const notification = useToastContext();
  const [tempImage, setTempImage] = useState([]);

  const UploadPhotos = async (data) => {
    const updatedPhotos = photos;

    try {
      const isValid = updatedPhotos?.length > 0 ? checkValidation() : true;
      if (!isValid) return;
      const temp = floorData?.filter((res) => {
        return res.title !== '' && res.image !== '';
      });
      const updatedTemp = temp?.filter((res) => {
        return typeof res?.image === 'object';
      });
      const updatedVideos = videoFile?.filter((res) => {
        return typeof res === 'object';
      });
      const formData = new FormData();
      if (updatedTemp?.length > 0) {
        formData.append(
          'title',
          JSON.stringify(
            updatedTemp.map((res) => {
              return res.title;
            })
          )
        );
        formData.append(
          'titleAr',
          JSON.stringify(
            updatedTemp.map((res) => {
              return res.titleAr;
            })
          )
        );
      }
      if (updatedTemp?.length > 0) {
        for (let i = 0; i < updatedTemp?.length; i++) {
          formData.append('floorPlan', updatedTemp[i].image);
        }
      }
      formData.append('_id', propertyId);
      if (typeof data?.threeSixtyView === 'undefined') {
        formData.append('threeSixtyView', '');
      } else {
        formData.append('threeSixtyView', data?.threeSixtyView);
      }
      if (deletedImage?.length > 0) {
        formData.append('deletePhotos', JSON.stringify(compact(deletedImage)));
      }
      if (deletedFloorPlan?.length > 0) {
        formData.append(
          'deleteFloorPlan',
          JSON.stringify(compact(deletedFloorPlan))
        );
      }
      if (deletedVideo?.length > 0) {
        formData.append('deleteVideos', JSON.stringify(compact(deletedVideo)));
      }
      if (updatedPhotos?.length > 0) {
        for (let i = 0; i < updatedPhotos?.length; i++) {
          const dbUrl = updatedPhotos[i]?.split(
            config?.country === 'Saudi' ? 'o/' : 'net/'
          );
          formData.append('photos', dbUrl[1]);
        }
      }
      if (updatedVideos?.length > 0) {
        for (let i = 0; i < updatedVideos?.length; i++) {
          formData.append('video', updatedVideos[i]);
        }
      }
      const { data: response } = await apiPost(apiPath.uploadPhotos, formData);
      if (response.success) {
        notification.success(response.message);
        setPropertyIdAndTabFn(response.results._id, TAB_UPLOAD_DOCUMENTS);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const addMoreFloor = () => {
    setFloorData([
      ...floorData,
      {
        title: '',
        titleAr: '',
        image: '',
      },
    ]);
  };

  const removeImage = async (index) => {
    if (typeof index !== 'object') {
      let check =
        tempImage?.length > 0
          ? tempImage?.find((res) => res?.image === index)
          : {};
      if (!isEmpty(check)) {
        apiPut(apiPath.deleteTempPhoto + check?._id, { type: 'property' });
        setTempImage((prev) => {
          return prev?.filter((res) => res.image !== index);
        });
        setPhotos((prev) => {
          return prev?.filter((res) => res !== index);
        });
      } else {
        const dbUrl = index?.split(config?.country === 'Saudi' ? 'o/' : 'net/');
        setDeletedImage((prev) => [...prev, dbUrl[1]]);
      }
    }
    setPhotos((prev) => {
      return prev.filter((res) => res !== index);
    });
  };

  const removeVideo = (item) => {
    const deleteVideo = videoFile.find((videoItem) => videoItem === item);
    if (deleteVideo) {
      const dbUrl = item?.split(config?.country === 'Saudi' ? 'o/' : 'net/');
      setDeletedVideo((prev) => [...prev, dbUrl[1]]);
    }
    const filteredVideo = createVideoUrl.filter(
      (videoItem) => videoItem !== item
    );
    setVideoFile(filteredVideo);
    if (typeof item === 'object') {
      const tempVideo = [...videoFile];
      const tempVideoItem = URL.createObjectURL(item);
      tempVideo.push(tempVideoItem);
      setCreateVideoUrl(tempVideo);
    } else {
      setCreateVideoUrl(filteredVideo);
    }
  };

  const handlePhotosChange = (e) => {
    const files = e.target.files;
    const tempFile = Object.values(files);
    if ([...selectedPhotos, ...tempFile, ...photos]?.length < imageCount) {
      notification.error('Please upload min 6 images.');
      return false;
    }
    if ([...selectedPhotos, ...tempFile].length > imageCountMax) {
      if (selectedPhotos.length === 0 && [...tempFile].length > imageCountMax) {
        notification.error('Only 10 photos are allowed to upload at a time.');
      } else if (
        selectedPhotos.length === imageCountMax &&
        [...selectedPhotos, ...tempFile].length > imageCountMax
      ) {
        notification.error('Only 10 photos are allowed to upload at a time.');
      } else if ([...selectedPhotos, ...tempFile, ...photos].length > 20) {
        notification.error('Max 20 photos are allowed to upload.');
      } else {
        notification.error(
          `Now you select only ${imageCountMax - selectedPhotos.length} photos.`
        );
      }
    } else {
      for (let i = 0; i < files?.length; i++) {
        const fileSize = helper.getFileSize(files[i]);
        const getType = files[i].type.split('/');
        if (PROPERTY_ALLOWED_PHOTO_EXT.includes(getType[1])) {
          if (fileSize > 2) {
            notification.error(
              'Please select photos below 2 MB (photos has been discarded which is above 2 MB)'
            );
          } else {
            uploadTemporaryPhotos(files[i]);
            // setPhotos(prev => {
            //   if (prev?.length > 0) {
            //     return [...prev, files[i]]
            //   } else {
            //     return [files[i]]
            //   }
            // })
          }
        } else {
          notification.error(
            `Only ${PROPERTY_ALLOWED_PHOTO_EXT.join(
              ', '
            )} photos are allowed to upload.`
          );
        }
      }
    }
  };

  const uploadTemporaryPhotos = async (e) => {
    const formData = new FormData();
    if (!isEmpty(propertyId)) {
      formData.append('propertyId', propertyId);
    }
    formData.append('image', e);
    const { data: response } = await apiPost(
      apiPath.uploadTemporaryPhotos,
      formData
    );
    if (response.success) {
      setTempImage((prev) => {
        return [...prev, response?.results];
      });
      setPhotos((prev) => {
        return [...prev, response?.results?.image];
      });
    } else {
      notification.error(response?.message);
    }
  };

  const singleVideo = (item) => {
    const getType = item.target.files[0].type.split('/');
    if (getType[0] !== undefined && getType[1] === 'mp4') {
      const fileSize = (item.target.files[0]?.size / (1024 * 1024)).toFixed(2);
      if (fileSize > 50) {
        notification.error('Please select video below 50 MB');
        return false;
      } else {
        return true;
      }
    } else {
      notification.error('Only mp4 video formats are allowed');
      return false;
    }
  };

  const multipleVideo = (item) => {
    for (let i = 0; i < item?.target?.files?.length; i++) {
      const getType = item.target.files[i].type.split('/');
      if (getType[0] !== undefined && getType[1] === 'mp4') {
        const fileSize = (item.target.files[i]?.size / (1024 * 1024)).toFixed(
          2
        );
        if (fileSize > 50) {
          notification.error('Please select video below 50 MB');
          return false;
        } else {
          return true;
        }
      } else {
        notification.error('Only mp4 video formats are allowed');
      }
    }
  };

  const handleChange = (event) => {
    if (event.target.files) {
      let tempVideoArray = [...videoFile];
      const videosFile = Object.values(event.target.files);
      tempVideoArray = [...tempVideoArray, ...videosFile];
      if (event?.target?.files?.length === 1) {
        const isValid = singleVideo(event);
        if (!isValid) return;
      } else if (event?.target?.files?.length === 2) {
        const isValid = multipleVideo(event);
        if (!isValid) return;
      }
      if (tempVideoArray.length > 2) {
        setIsVideoFileError('Please select only two video files.');
      } else {
        const tempVideo = [];
        const tempVideoFile = [];
        Object.values(event.target.files).forEach((item) => {
          if (item?.type?.includes('/mp4')) {
            tempVideo.push(URL.createObjectURL(item));
            tempVideoFile.push(item);
          }
        });
        setVideoFile([...videoFile, ...tempVideoFile]);
        const tempCreateVideo = [...tempVideo, ...createVideoUrl];
        setCreateVideoUrl(tempCreateVideo);
        setIsVideoFileError('');
      }

      event.target.value = null;
    }
  };

  const checkValidation = () => {
    const updatedPhotos = [...photos];
    if (editProperty?.photos?.length === 0) {
      if (updatedPhotos?.length < imageCount) {
        notification.error('Please upload min 6 images.');
        return false;
      } else if (updatedPhotos?.length > 10) {
        notification.error('You can only select 10 image at a time');
        return false;
      }
    } else {
      if (tempImage?.length > 10) {
        notification.error('You can only select 10 image at a time');
        return false;
      }
      if (
        editProperty?.photos?.length +
          tempImage?.length -
          deletedImage?.length >
        imageCountMax
      ) {
        notification.error(
          `property image should not more than ${imageCountMax}`
        );
        return false;
      }
      if (
        editProperty?.photos?.length +
          tempImage?.length -
          deletedImage?.length <
        imageCount
      ) {
        notification.error('Please upload min 6 images.');
        return false;
      }
    }
    if (videoFile?.length > 2) {
      notification.error('property video should not more than 2');
      return false;
    }
    return true;
  };

  const handleFileUploadSingle = (e) => {
    const getType = e.target.files[0].type.split('/');
    const fileSize = (e.target.files[0]?.size / (1024 * 1024)).toFixed(2);
    if (
      getType[1] !== undefined &&
      (getType[1] === 'jpeg' ||
        getType[1] === 'png' ||
        getType[1] === 'jpg' ||
        getType[1] === 'gif')
    ) {
      if (fileSize > 2) {
        notification.error('Please select image below 2 MB');
      } else {
        return true;
      }
    } else {
      notification.error('Only jpeg,png,jpg,gif formats are allowed');
    }
  };

  const handelFloorPhotos = (index, item) => {
    const check = handleFileUploadSingle(item);
    if (check) {
      setFloorData(
        floorData?.map((res, ind) => {
          if (index === ind) {
            return {
              ...res,
              image: item.target.files[0],
            };
          } else {
            return res;
          }
        })
      );
    }
  };

  const deleteFloorPlan = (index, img) => {
    if (typeof img !== 'object') {
      const dbUrl = img?.split(config?.country === 'Saudi' ? 'o/' : 'net/');
      setDeletedFloorPlan((prev) => [...prev, dbUrl[1]]);
    }
    setFloorData(
      floorData.filter((percentage, tempIndex) => tempIndex !== index)
    );
    setIsFloorError('');
  };

  useEffect(() => {
    if (editProperty?.threeSixtyView !== 'undefined')
      setValue('threeSixtyView', editProperty?.threeSixtyView);
  }, [reArrange]);

  useEffect(() => {
    setPhotos(editProperty?.photos);
    if (editProperty?.floorPlan?.length > 0) {
      setFloorData(
        editProperty?.floorPlan.map((res) => {
          return {
            ...res,
            disabled: true,
          };
        })
      );
    }
  }, [editProperty]);

  const dragItem = useRef();
  const dragOverItem = useRef();

  const dragStart = (e, position) => {
    dragItem.current = position;
    console.log(e.target.innerHTML);
  };

  const dragEnter = (e, position) => {
    dragOverItem.current = position;
  };

  const drop = (e) => {
    const copyListItems = [...photos];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setPhotos(copyListItems);
  };

  return (
    <>
      <div className="flex justify-between items-center">
        <div>
          <h4 className="text-lg font-semibold pt-3">
            {t('UPLOAD_PROPERTY_PHOTOS')}
          </h4>
          {/* <span className='block text-red-500'>
            {t('PHOTOS_MUST_BE_UPLOADED_IN_ORDER_TO_REARRANGE_THE_PHOTOS')}
          </span> */}
        </div>
      </div>
      <div className="photo_list flex flex-wrap gap-5 mt-2">
        <div
          className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer"
          onClick={() => profilePicRef?.current?.click()}
        >
          <div className="text-center">
            <img src="../images/uploadimg.png" className="m-auto" alt="" />
            <strong className="my-2 block text-xl">{t('ADD_PHOTO')}</strong>
            <strong className="my-2 block ">{t('(Max 2 MB/photo)')}</strong>
            <span className="block text-sm font-medium">
              {t('MIN_IMAGE_TEXT')}
            </span>
            <input
              type="file"
              accept="image/jpg, image/jpeg"
              name="image"
              ref={profilePicRef}
              onChange={handlePhotosChange}
              className="hidden"
              multiple
            />
          </div>
        </div>
        {photos?.map((item, index) => (
          <div
            key={index}
            onDragStart={(e) => dragStart(e, index)}
            onDragEnter={(e) => dragEnter(e, index)}
            onDragEnd={drop}
            draggable
            style={{ cursor: 'move' }}
            className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px]  rounded-md relative overflow-hidden"
          >
            <figure className="w-full h-full">
              <OImage
                src={
                  typeof item === 'object' ? URL.createObjectURL(item) : item
                }
                fallbackUrl="/images/user.png"
                className="w-full h-full object-cover"
                alt=""
              />
            </figure>
            {/* {isDeletePhoto && ( */}
            <button
              className="absolute top-[10px] right-[10px]"
              onClick={() => removeImage(item)}
            >
              <img src={photoClose} alt="" />
            </button>
            {/* )} */}
          </div>
        ))}
      </div>

      <hr className="mt-10 mb-5" />
      <form>
        <h4 className="text-lg font-semibold py-3">
          {t('UPLOAD_URL_360_VISUAL_AND_VIDEO')}
        </h4>

        <div className="flex  gap-4 xl:gap-12 ">
          <div className="py-3 mb-1 flex-0 w-1/2 xl:w-1/3">
            <label className="block">
              {/* <span className='block text-sm font-medium text-gray-400'>
                {t('ADD_VISUAL_360_URL')}
              </span> */}
              {/* <div className='flex border rounded-md overflow-hidden mt-1'> */}
              {/* <input
                  type='text'
                  placeholder='Enter URL'
                  className=' px-3 py-3 bg-white border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1'
                  {...register('threeSixtyView', {
                    // required: '360 view url is required.',
                    // minLength: {
                    //   value: 2,
                    //   message: 'Minimum length must be 2.'
                    // },
                    // validate: value => {
                    //   return value.trim() ? true : 'White spaces not allowed.'
                    // },
                    pattern: {
                      value:
                        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
                      message: 'Invalid url (Ex: https://www.google.com/).'
                    }
                  })}
                /> */}
              <OInputField
                wrapperClassName="relative z-0 w-full group"
                name="threeSixtyView"
                inputLabel={t('ADD_VISUAL_360_URL')}
                type="text"
                register={register('threeSixtyView', {
                  pattern: {
                    value:
                      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
                    message: 'Invalid url (Ex: https://www.google.com/).',
                  },
                })}
                errors={errors}
              />
            </label>
          </div>

          <div className="py-3 mb-1 flex-0 w-1/2 xl:w-1/3">
            <label className="block">
              <OFileInput
                wrapperClassName="relative z-0 w-full group"
                name="videos"
                inputLabel={t('UPLOAD_VIDEO')}
                multiple
                accept="video/mp4,video/*,.mkv"
                onChange={(e) => handleChange(e)}
                // register={register('videos')}
                errors={errors}
              />
              {isVideoFileError && <ErrorMessage message={isVideoFileError} />}
            </label>

            <div className="flex justify-between mt-5">
              {createVideoUrl?.length > 0 &&
                createVideoUrl?.map((item, index) => (
                  <div
                    key={index}
                    className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded border-2 relative overflow-hidden p-2"
                  >
                    <video
                      className="w-full h-full m-auto object-cover"
                      controls
                      width="320"
                      height="240"
                      src={
                        // typeof item === 'string'
                        //   ? item
                        //   : URL.createObjectURL(item)
                        item
                      }
                    />
                    <button
                      type="button"
                      className="absolute top-[10px] right-[10px]"
                      onClick={() => removeVideo(item)}
                    >
                      <img src={photoClose} alt="" />
                    </button>
                  </div>
                ))}
            </div>
          </div>
        </div>

        <hr className="mt-10 mb-5" />

        <h4 className="text-lg font-semibold py-3">
          {t('UPLOAD_FLOOR_PLAN_PHOTOS')}
        </h4>

        {floorData?.length > 0 &&
          floorData?.map((item, index) => {
            return (
              <div className="flex  gap-4 xl:gap-12 " key={index}>
                <div className="py-3 mb-1 flex-0 w-1/2 xl:w-1/3">
                  <label className="block">
                    <span className="block text-sm font-medium text-gray-400">
                      {t('O_TITLE')}
                    </span>
                    <input
                      type="text"
                      name={index}
                      disabled={item?.disabled}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder={t('O_TITLE')}
                      value={item?.title}
                      onChange={(e) => {
                        setFloorData(
                          floorData?.map((res, ind) => {
                            if (ind === index) {
                              return { ...res, title: e.target.value };
                            } else {
                              return res;
                            }
                          })
                        );
                      }}
                    />
                  </label>
                </div>
                <div className="py-3 mb-1 flex-0 w-1/2 xl:w-1/3">
                  <label className="block">
                    <span className="block text-sm font-medium text-gray-400">
                      {t('O_TITLE') + t('O_ARABIC')}
                    </span>
                    <input
                      type="text"
                      name={index}
                      disabled={item?.disabled}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder={t('O_TITLE') + t('O_ARABIC')}
                      value={item?.titleAr}
                      onChange={(e) => {
                        setFloorData(
                          floorData?.map((res, ind) => {
                            if (ind === index) {
                              return { ...res, titleAr: e.target.value };
                            } else {
                              return res;
                            }
                          })
                        );
                      }}
                    />
                  </label>
                </div>

                <div className="py-3 mb-1 flex-0 w-1/2 xl:w-1/3">
                  <label className="block">
                    <span className="block text-sm font-medium text-gray-400">
                      {t('O_SIZE_FLOOR_PLAN')}
                    </span>
                    <div className="flex items-center">
                      <div className="relative flex border rounded-md overflow-hidden mt-1 truncate">
                        <span className="absolute p-3 pr-9 left-0 right-0 top-auto truncate">
                          {t('UPLOAD_FLOOR_PLAN_PHOTOS')}
                        </span>
                        <input
                          type="file"
                          placeholder="10.95"
                          disabled={item?.disabled}
                          onChange={(e) => handelFloorPhotos(index, e)}
                          className="opacity-0 px-3 py-3 bg-transparent relative z-10 border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1"
                        />
                        <button className="flex items-center justify-center absolute right-0 top-4 text-white text-sm rounded-r w-[64px]">
                          <img src="../images/upload.svg" alt="" />
                        </button>
                      </div>
                      {item?.image && (
                        <div className=" ml-3 h-16 w-16 overflow-hidden border-4  rounded-full">
                          <img
                            src={
                              typeof item?.image === 'object'
                                ? URL.createObjectURL(item?.image)
                                : item?.image
                            }
                            alt=""
                            className="w-full h-full object-cover"
                          />
                        </div>
                      )}
                      <button
                        type="button"
                        className="ml-3  text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]"
                        onClick={() => deleteFloorPlan(index, item?.image)}
                      >
                        <span className=" text-[#222]  text-lg " title="Close">
                          ×
                        </span>
                      </button>
                    </div>
                  </label>
                  {isFloorError && <ErrorMessage message={isFloorError} />}
                </div>
              </div>
            );
          })}

        <button className="text-blue-400" type="button" onClick={addMoreFloor}>
          {t('ADD_MORE')}
        </button>

        <div className="border-t mt-10 py-10">
          <button
            className="mr-6 bg-white hover:bg-[#8FC150] hover:border-black hover:text-white cursor-pointer   text-lime-500 border-2 border-lime-500  font-normal active:bg-slate-100 text-md px-8 py-2 rounded hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150
                undefined "
            onClick={() => setTab(tabs.TAB_ADDRESS)}
          >
            {t('GO_BACK')}
          </button>

          <button
            type="button"
            className={`bg-lime-500 hover:bg-[#8FC150]   text-white  font-normal active:bg-slate-100 text-md px-8 py-2.5 rounded  hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150
                undefined `}
            onClick={handleSubmit(UploadPhotos, () => checkValidation)}
          >
            {t('SAVE_&_CONTINUE')}
          </button>
        </div>
      </form>

      {isShowModal && (
        <ReArrangeModal
          setIsShowModal={setIsShowModal}
          UploadPhotos={UploadPhotos}
          photos={photos}
          removeImage={removeImage}
          propertyId={propertyId}
          getPropertyById={getPropertyById}
          setReArrange={setReArrange}
          reArrange={reArrange}
        />
      )}
    </>
  );
}

export default Photos;
